(() => {
  const initCulmDrawer = () => {
    const drawer = document.getElementById('culm-menu-drawer');
    const openers = [...document.querySelectorAll('[data-culm-drawer-open]')];
    if (!drawer || !openers.length) return;

    const closers = [...drawer.querySelectorAll('[data-culm-drawer-close]')];
    const panel = drawer.querySelector('.culm-menu-drawer__panel');
    let previousFocus = null;

    const focusable = () => [...drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
      .filter((el) => el.offsetParent !== null);

    const openDrawer = (opener) => {
      previousFocus = opener || document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openers.forEach((button) => button.setAttribute('aria-expanded', 'true'));
      document.documentElement.classList.add('culm-menu-open');
      document.body.classList.add('culm-menu-open');
      window.requestAnimationFrame(() => drawer.querySelector('.culm-menu-drawer__close')?.focus());
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openers.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      document.documentElement.classList.remove('culm-menu-open');
      document.body.classList.remove('culm-menu-open');
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    };

    openers.forEach((button) => button.addEventListener('click', () => openDrawer(button)));
    closers.forEach((button) => button.addEventListener('click', closeDrawer));
    drawer.querySelectorAll('a[href]').forEach((link) => link.addEventListener('click', closeDrawer));

    document.addEventListener('keydown', (event) => {
      if (!drawer.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      const items = focusable();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (panel && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const orbit = drawer.querySelector('.culm-menu-orbit');
      panel.addEventListener('pointermove', (event) => {
        if (!orbit || window.innerWidth < 801) return;
        const x = event.clientX / window.innerWidth - .5;
        const y = event.clientY / window.innerHeight - .5;
        orbit.style.transform = `rotate(${x * 7}deg) translate3d(${x * -24}px, ${y * -18}px, 0)`;
      }, { passive: true });
      panel.addEventListener('pointerleave', () => {
        if (orbit) orbit.style.transform = '';
      }, { passive: true });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCulmDrawer);
  else initCulmDrawer();
})();
